import { LocationType } from '@app/inputs/inputs-api.model';
import { InputSessionAPIModel, ViewModel } from '../inputs/event/event.model';
import { transformDateAndTimeToUTC } from '../inputs/course/services/course.utils';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { LocalityViewModel } from '@app/shared/components/address-suggest/address-suggest.service';
import { SessionDetailsFormModel } from '../inputs/shared/components/session-details/session-details.component';

export const parseSessionDataForBE = (
  sessionDetails: SessionDetailsFormModel,
  sessionLocation: LocalityViewModel,
  isSessionDetailsToggledOn: boolean,
  datehandler: NgbDateParserFormatter
): InputSessionAPIModel[] => {
  if (!isSessionDetailsToggledOn) {
    return [];
  }

  const {
    endDate,
    endTime,
    isRegistrationAvailable,
    isRegistrationUrlInputUrl,
    locationAddress,
    locationType,
    locationUrl,
    startDate,
    startTime,
    registrationUrl,
    timeZoneId,
  } = sessionDetails;

  return [
    {
      ...sessionLocation,
      isRegistrationAvailable,
      isRegistrationUrlInputUrl,
      endDateTime: transformDateAndTimeToUTC(endDate, endTime, datehandler),
      locationAddress,
      locationType: getLocationType(locationType),
      locationUrl,
      registrationUrl,
      startDateTime: transformDateAndTimeToUTC(
        startDate,
        startTime,
        datehandler
      ),
      timeZoneId,
    },
  ];
};

export const addSessionLocationToVM = (model: Partial<ViewModel>) => {
  const session = model.sessions?.[0];
  return {
    ...model,
    sessionLocation: {
      locationAddress: session?.locationAddress,
      city: session?.city,
      country: session?.country,
      countryCode: session?.countryCode,
      latitude: session?.latitude,
      longitude: session?.longitude,
    },
  };
};

export const getLocationType = ({
  isOnline,
  isInPerson,
}: SessionDetailsFormModel['locationType']): LocationType =>
  isOnline && isInPerson
    ? LocationType.Hybrid
    : isOnline
      ? LocationType.Online
      : isInPerson
        ? LocationType.InPerson
        : undefined;
